var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "wysiwyg",
      class: [_vm.theme, _vm.layout_choice],
      style: {
        "--padding-top": _vm.parsedData.padding_top + "px",
        "--padding-bottom": _vm.parsedData.padding_bottom + "px",
        "--padding-top-mobile": _vm.parsedData.padding_top_mobile + "px",
        "--padding-bottom-mobile": _vm.parsedData.padding_bottom_mobile + "px",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "container",
          style: { "--list-image": "url(" + _vm.list_image + ")" },
        },
        [
          _vm.title
            ? _c(
                "div",
                { staticClass: "title", class: [_vm.theme, _vm.layout_choice] },
                [_c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "wysiwyg__inner",
              class: [_vm.theme, _vm.layout_choice],
            },
            [
              _vm.wysiwyg
                ? _c("span", {
                    staticClass: "body",
                    domProps: { innerHTML: _vm._s(_vm.wysiwyg) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.parsedPrimaryCta || _vm.parsedSecondaryCta
                ? _c(
                    "div",
                    {
                      staticClass: "cta_wrapper",
                      class: { no_body: !_vm.wysiwyg },
                    },
                    [
                      _vm.parsedPrimaryCta
                        ? _c("secondary-button", {
                            class: [_vm.theme, _vm.layout_choice],
                            attrs: {
                              label: _vm.parsedPrimaryCta.title,
                              link: _vm.parsedPrimaryCta,
                              theme: { reverse: _vm.theme === "blue" },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.parsedSecondaryCta
                        ? _c("tertiary-button", {
                            class: [_vm.theme, _vm.layout_choice],
                            attrs: {
                              label: _vm.parsedSecondaryCta.title,
                              link: _vm.parsedSecondaryCta,
                              theme: { reverse: _vm.theme === "blue" },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }